import type { HTMLProps } from 'react';

import { cn } from '~/lib/cn';
import {
  type BreadcrumbItem,
  BreadcrumbList,
} from '~settings/components/BreadcrumbList';

export type HeaderProps = {
  breadcrumbs?: React.ReactNode;
  breadcrumbItems?: BreadcrumbItem[];
  children?: React.ReactNode;
} & HTMLProps<HTMLDivElement>;

export function Header({
  breadcrumbs,
  breadcrumbItems,
  children,
  className,
  ...props
}: HeaderProps) {
  return (
    <header
      className={cn('relative', 'flex', 'flex-col', 'gap-lg', className)}
      {...props}
    >
      {breadcrumbItems ? (
        <BreadcrumbList breadcrumbItems={breadcrumbItems} />
      ) : (
        breadcrumbs
      )}
      <div className="flex items-center justify-between gap-md">{children}</div>
    </header>
  );
}
Header.displayName = 'Header';
